/**
 * <dbr-imagem-texto> — imagem de fundo com parallax sutil ao rolar
 * (translateY, GPU), com liga/desliga independente pra desktop e mobile.
 * Mesma técnica de dbr-ciencia.js, generalizada pros dois breakpoints e
 * com intensidade configurável via editor.
 *
 * Depende de gsap.min.js + gsap-scrolltrigger.min.js + dbr-animation-core.js
 * carregados uma única vez em layout/theme.liquid (não aqui — ver
 * comentário em theme.liquid sobre por que isso é global, não
 * por-section).
 */
class DbrImagemTexto extends HTMLElement {
  connectedCallback() {
    this.bgImage = this.querySelector('.dbr-imagem-texto__bg-image');
    if (!this.bgImage) return;

    this.parallaxDesktop = this.dataset.parallaxDesktop === 'true';
    this.parallaxMobile = this.dataset.parallaxMobile === 'true';
    this.intensity = parseFloat(this.dataset.parallaxIntensity) || 8;

    if (window.DbrAnim && window.DbrAnim.reducedMotion) return;

    if (window.DbrAnim) {
      window.DbrAnim.ready(this.setup.bind(this));
    }
  }

  setup(gsap) {
    var self = this;

    this.mm = gsap.matchMedia();

    this.mm.add(
      {
        isDesktop: '(min-width: 750px)',
        isMobile: '(max-width: 749px)',
      },
      function (context) {
        var isMobile = context.conditions.isMobile;
        var enabled = isMobile ? self.parallaxMobile : self.parallaxDesktop;
        if (!enabled) return;

        var tween = gsap.fromTo(
          self.bgImage,
          { yPercent: -self.intensity },
          {
            yPercent: self.intensity,
            ease: 'none',
            scrollTrigger: { trigger: self, start: 'top bottom', end: 'bottom top', scrub: 0.6 },
          }
        );

        return function cleanup() {
          tween.scrollTrigger && tween.scrollTrigger.kill();
          tween.kill();
        };
      }
    );
  }

  disconnectedCallback() {
    if (this.mm) this.mm.revert();
  }
}

if (!customElements.get('dbr-imagem-texto')) {
  customElements.define('dbr-imagem-texto', DbrImagemTexto);
}
